import checkRetractionForErrors from "~/store/manage/validation/checkRetractionForErrors";

const VALIDATE_RETRACTION = (state) => {
  const retractionItem = state.retractionItem;

  state.retractionErrors = checkRetractionForErrors(retractionItem);
};

export default VALIDATE_RETRACTION;
